module.exports = __webpack_public_path__ + "static/media/NU.4d01f4d6.svg";